import { gql } from 'apollo-boost'

export const OPEN_PAYMENT_SLIP = gql`
  mutation openPaymentSlip($input: OpenPaymentSlipInput!) {
    openPaymentSlip(input: $input) {
      message
    }
  }
`
